import { api } from '../api';
import { unit, useLoad } from '../lib';

// One offer's price history, newest first — the migrated Magento price log plus every price the
// rebuild has written (feeds, approved requests). Read-only. The newest 100 changes.
export function PriceHistoryView({ offerId }: { offerId: number }) {
  const { data, err } = useLoad(() => api.commercePriceHistory(offerId), [offerId]);
  if (err) return <p className="msg bad">⚠ {err === 'not found' ? `No offer #${offerId}.` : err}</p>;
  if (!data) return <p className="loading">Loading price history…</p>;
  const { offer, rows } = data;
  return (
    <div>
      <p className="small">
        Offer #{offer.id} <span className="mono">{offer.supplier_sku ?? ''}</span> · now {unit(offer.price)}
        {offer.status !== 1 && <span className="muted"> (offer disabled)</span>}
      </p>
      {rows.length === 0 ? <p className="muted small">No price change recorded for this offer.</p> : (
        <table>
          <thead><tr><th>Changed</th><th className="num">From</th><th className="num">To</th><th className="num">Change</th><th>By</th></tr></thead>
          <tbody>
            {rows.map((h) => {
              const pct = h.old_price && h.new_price != null ? ((h.new_price - h.old_price) / h.old_price) * 100 : null;
              return (
                <tr key={h.id}>
                  <td className="mono muted">{h.changed_at?.slice(0, 16) ?? '—'}</td>
                  <td className="num">{unit(h.old_price)}</td>
                  <td className="num">{unit(h.new_price)}</td>
                  <td className="num muted">{pct == null ? '—' : `${pct > 0 ? '+' : ''}${pct.toFixed(1)}%`}</td>
                  <td>{h.admin_user ?? <span className="muted">—</span>}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
      {rows.length === 100 && <p className="muted small">Showing the newest 100 changes.</p>}
    </div>
  );
}
